export const PROCESSING = 'PROCESSING';
export const GET_TYPES = 'GET_TYPES';
export const GET_METADATA = 'GET_METADATA';
export const START_VALIDATION_RESULT = 'START_VALIDATION_RESULT';
export const GET_VALIDATION_RESULT = 'GET_VALIDATION_RESULT';
export const GET_BULK_REQUESTS = 'GET_BULK_REQUESTS';
export const GET_BULK_REQUESTS_COUNT = 'GET_BULK_REQUESTS_COUNT';
export const GET_ITEMS = 'GET_ITEMS';
export const GET_ITEM_COUNT = 'GET_ITEM_COUNT';
export const START_BULK_UPLOAD_REQUEST = 'START_BULK_UPLOAD_REQUEST';
export const END_BULK_UPLOAD_REQUEST = 'END_BULK_UPLOAD_REQUEST';
export const UPLOAD_BULK_REQUEST = 'UPLOAD_BULK_REQUEST';
export const ABORT_BULK_UPLOAD = 'ABORT_BULK_UPLOAD';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
